import {Livewire} from "../../vendor/livewire/livewire/dist/livewire.esm";

import "./alpine.js";
import "./bars.js";

import "./form.js";
import "./unsaved.js";   // unsaved changes stop a page being left; Auto-Save
import "./media.js";
import "./upload.js";   // file fields send in pieces
import "./text.js";

import "./toaster.js";
import "./errors.js";   // a failed request: a plain note, and the page as it is now
import "./permissions.js";   // a card before the browser asks for location, notifications or the camera

import "./splide.js";

import "./countdown.js";

import "./revolut.js";
import "./paypal.js";
import "./stripe.js";

import "./signature-pad.js";
import "./inputs.js";
import "./scanner.js";
import "./pdf.js";
import "./photo-editor.js";   // turn and crop a photo (Cropper.js loads on first use)

import "./captcha.js";

import "./consent.js";   // analytics, only with consent

import "./download.js";
import "./serviceworker.js";
import "./install.js";
import "./share.js";
import "./contact-links.js";   // phone links on a computer: copied and shown; email links in a new tab
import "./places.js";      // maps of places, the visitor among them (livewire/location/map)

// Appearance chosen in Preferences: the page changes at once (<html data-appearance>; App\Classes\Theme)
window.appearance = (mode) => document.documentElement.dataset.appearance = mode;

// A file this page loads later gone after all (a deploy over a week after the page opened): the page afresh, once a minute at most
window.addEventListener('vite:preloadError', (event) => {
    try {
        if (Date.now() - Number(sessionStorage.getItem('reloaded-for-assets') || 0) < 60000) return;
        sessionStorage.setItem('reloaded-for-assets', String(Date.now()));
    } catch { return; }
    event.preventDefault();
    location.reload();
});

Livewire.start();
